import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import SignUp from '@/views/SignUp.vue';
import Dashboard from '@/views/dashboard/Dashboard.vue';
import LogIn from '@/views/LogIn.vue';
import MyAccount from '@/views/dashboard/MyAccount.vue';
import ThirdParties from '@/views/dashboard/ThirdParties.vue';
import ThirdParty from '@/views/dashboard/ThirdParty.vue';
import AddThirdParty from '@/views/dashboard/AddThirdParty.vue';
import EditThirdParty from '@/views/dashboard/EditThirdParty.vue';
import EditOrganization from '@/views/dashboard/EditOrganization.vue';
import Documents from '@/views/dashboard/Documents.vue';
import Document from '@/views/dashboard/Document.vue';
import AddDocument from '@/views/dashboard/AddDocument.vue';
import InventoryView from '@/views/dashboard/Inventory.vue';
import ItemDetail from '@/views/dashboard/ItemDetail.vue';
import AddItem from '@/views/dashboard/AddItem.vue';
import Manage from '@/views/settings/Manage.vue';
import Analytics from '@/views/analytics/Analytics.vue';
import ActivityPanel from '@/views/settings/ActivityPanel.vue';
import PeppolCompany from '@/views/peppol/PeppolCompany.vue';
import PeppolDocuments from '@/views/peppol/PeppolDocuments.vue';
//import ThirdPartyAnalyticsPicker from '@/views/analytics/ThirdPartyAnalyticsPicker.vue';

import store from '@/store';
import FileImport from '@/views/settings/FileImport.vue';
import DashboardImport from '@/views/settings/DashboardImport.vue';
import OnboardingWizard from '@/views/wizard/OnboardingWizard.vue';
import Preferences from '@/views/settings/Preferences.vue';
import PeppolVerify from '@/views/peppol/PeppolVerify.vue';
import PeppolInbox from '@/views/peppol/PeppolInbox.vue';
import PeppolDocumentDetail from '@/views/peppol/PeppolDocumentDetail.vue';
const routes: Array<RouteRecordRaw> = [
  // Public
  { path: '/', name: 'home', component: HomeView },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
  },

  // Auth (guest-only)
  {
    path: '/sign-up',
    name: 'SignUp',
    component: SignUp,
    meta: { guestOnly: true },
  },
  {
    path: '/log-in',
    name: 'LogIn',
    component: LogIn,
    meta: { guestOnly: true },
  },

  // Dashboard & Account (private)
  {
    path: '/dashboard',
    name: 'DashboardView',
    component: Dashboard,
    meta: { requireLogin: true },
  },
  {
    path: '/dashboard/my-account',
    name: 'MyAccount',
    component: MyAccount,
    meta: { requireLogin: true },
  },
  {
    path: '/dashboard/my-account/edit-organization',
    name: 'EditOrganization',
    component: EditOrganization,
    meta: { requireLogin: true },
  },

  // Third Parties (private)
  {
    path: '/dashboard/third-parties',
    name: 'DashboardThirdParties',
    component: ThirdParties,
    meta: { requireLogin: true },
  },
  {
    path: '/dashboard/third-parties/add',
    name: 'AddThirdParty',
    component: AddThirdParty,
    meta: { requireLogin: true },
  },
  {
    path: '/dashboard/third-parties/:id',
    name: 'ThirdPartyView',
    component: ThirdParty,
    meta: { requireLogin: true },
  },
  {
    path: '/dashboard/third-parties/:id/edit',
    name: 'EditThirdParty',
    component: EditThirdParty,
    meta: { requireLogin: true },
  },

  // Documents (private)
  {
    path: '/dashboard/documents',
    name: 'DashboardDocuments',
    component: Documents,
    meta: { requireLogin: true },
  },
  {
    path: '/dashboard/documents/add',
    name: 'AddDocument',
    component: AddDocument,
    meta: { requireLogin: true },
  },
  {
    path: '/dashboard/document/:id',
    name: 'DetailDocument',
    component: Document,
    meta: { requireLogin: true },
  },
  {
    path: '/dashboard/documents/:id/edit',
    name: 'EditDocument',
    component: AddDocument,
    props: { editMode: true },
    meta: { requireLogin: true },
  },

  // Inventory (private)
  {
    path: '/dashboard/inventory',
    name: 'DashboardInventory',
    component: InventoryView,
    meta: { requireLogin: true },
  },
  {
    path: '/dashboard/items/:id',
    name: 'ItemDetail',
    component: ItemDetail,
    props: { editMode: true },
    meta: { requireLogin: true },
  },
  {
    path: '/dashboard/inventory/add',
    name: 'AddItem',
    component: AddItem,
    meta: { requireLogin: true },
  },
  // Settings
  {
    path: '/settings/manage',
    name: 'ManageView',
    component: Manage,
    meta: { requireLogin: true, roles: ['admin', 'owner'] },
  },
  // Analytics
  {
    path: '/analytics',
    name: 'AnalyticsView',
    component: Analytics,
    meta: { requireLogin: true },
  },
  //Activity log
  {
    path: '/settings/activity-log',
    name: 'ActivityPanel',
    component: ActivityPanel,
    meta: { requireLogin: true, roles: ['admin', 'owner'] },
  },
  {
    path: '/settings/dashboard-import',
    name: 'DashboardImport',
    component: DashboardImport,
    meta: { requireLogin: true },
  },
  {
    path: '/onboarding',
    name: 'OnboardingOrganization',
    component: OnboardingWizard,
    meta: { requireLogin: true, roles: ['admin', 'owner'] },
  },
  {
    path: '/dashboard/preferences',
    name: 'PreferencesView',
    component: Preferences,
    meta: { requiresAuth: true },
  },

  {
    path: '/onboarding/preferences',
    name: 'OnboardingPreferences',
    component: () => import('@/views/wizard/OnboardingPreferences.vue'),
    meta: { requireLogin: true },
  },
  {
    path: '/organization/peppol',
    name: 'PeppolCompany',
    component: PeppolCompany,
    meta: { requiresAuth: true },
  },
  {
    path: '/organization/peppol-verify',
    name: 'PeppolVerify',
    component: PeppolVerify,
    meta: { requiresAuth: true },
  },
  {
    path: '/organization/peppol-documents',
    name: 'PeppolDocuments',
    component: PeppolDocuments,
    meta: { requiresAuth: true },
  },
  {
    path: '/organization/peppol-inbox',
    name: 'PeppolInbox',
    component: PeppolInbox,
    meta: { requiresAuth: true },
  },
  {
    path: '/organization/peppol-documents/:id',
    name: 'PeppolDocumentDetail',
    component: PeppolDocumentDetail,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, _from, next) => {
  const requiresAuth = to.matched.some((r) => r.meta?.requireLogin === true);
  const guestOnly = to.matched.some((r) => r.meta?.guestOnly === true);

  const isLogged = store.getters.isLogged;
  const user = store.getters.currentUser || null;

  // 1) Block private pages for guests
  if (requiresAuth && !isLogged) {
    return next('/log-in');
  }

  // 2) Keep logged users away from guest-only pages
  if (guestOnly && isLogged) {
    return next('/');
  }

  // 3) Role-based guard
  const needRoles = (to.meta?.roles as string[] | undefined) ?? null;
  if (needRoles && needRoles.length) {
    const staffish = user?.is_staff || user?.is_superuser;
    const memberships = user?.memberships || [];
    const userRoles = memberships.map((m: any) =>
      String(m.role || '').toLowerCase()
    );

    const allowed =
      staffish ||
      userRoles.some((r: string) =>
        needRoles.map((rr) => rr.toLowerCase()).includes(r)
      );

    if (!allowed) {
      return next('/');
    }
  }

  // 4) Wizard 1
  if (
    user &&
    user.is_owner &&
    !user.org_onboarded &&
    to.name !== 'OnboardingOrganization'
  ) {
    return next({ name: 'OnboardingOrganization' });
  }

  // 5) Wizard 2
  if (
    user &&
    user.org_onboarded &&
    !user.prefs_onboarded &&
    to.name !== 'OnboardingPreferences'
  ) {
    return next({ name: 'OnboardingPreferences' });
  }
  next();
});

export default router;
